module.exports = __webpack_public_path__ + "static/media/check.d98a42ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/check.svg
// module id = 1437
// module chunks = 2